import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import axios from "axios";
import useSWR from "swr";
import { FormikAsyncSelect } from "../AsyncSelect";
import { usePermission } from "../../hooks";
import permissions from "../../_common/permissions";

const fetcher = url => axios.get(url).then(res => res.data);

function AsyncSelectOrigem({ name, ...props }) {
  const { data: origens, mutate: recarregarLista } = useSWR("/api/pipeline/origem/listar?somenteAtivos=true", fetcher);
  const nomeCampo = props.field.name;
  const labelCampo = props.label;
  const permissao = usePermission(permissions.ORIGEM_SUBORIGEM);
  const { values, setFieldValue } = useFormikContext();
  const { origem: origemAtual = {}, subOrigem: subOrigemAtual = {} } = values || {};

  const resetSubOrigem = () => {
    setFieldValue("subOrigem", { ...subOrigemAtual, id: "", descricao: "" });
  };

  const handleChangeOrigem = (e, origem) => {
    if (!origem) {
      setFieldValue("origem", { ...origemAtual, id: "", descricao: "" });
      resetSubOrigem();
      return;
    }

    if (props.desbloquearSubOrigem) props.desbloquearSubOrigem(false);
    setFieldValue("origem", { ...origemAtual, ...origem });
    resetSubOrigem();
  };

  return (
    <FormikAsyncSelect
      name={nomeCampo}
      id={nomeCampo}
      options={origens}
      value={origemAtual.id || ""}
      label={labelCampo}
      onChange={handleChangeOrigem}
      criarNovo={permissao}
      urlCriarNovo={"/spotter/configuracoes/padroes"}
      funcaoRecarregar={recarregarLista}
      fullWidth
      enableSearch
      {...props}
    />
  );
}

AsyncSelectOrigem.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  field: PropTypes.object,
  desbloquearSubOrigem: PropTypes.func,
};

export default AsyncSelectOrigem;
